import React, { useState, useEffect } from "react";
import "./popupLogin.css";
import { connect } from "react-redux";

function AcadmicYear(props) {
  const isLoginViaToken = sessionStorage.getItem("loginViaToken") === "true";

  const defaultYear =
    isLoginViaToken &&
    props?.acad_year_list?.find(
      (year) =>
        year.inst_acad_year === props?.student_acad_year[0]?.acad_yr_id
    );

  const [selected, setSelected] = useState(
    defaultYear?.acad_yr_id || props?.student_acad_year[0]?.acad_yr_id
  );

  useEffect(() => {
    if (isLoginViaToken && defaultYear?.acad_yr_id) {
      props.dispatch({
        type: "SWITCH_ACAD_YEAR_NEW",
        acadYearObj: defaultYear.acad_yr_id,
        dashNavigate: () => {
          const redirectUrl = sessionStorage.getItem("redirectUrl") || "/dashboard";
          sessionStorage.removeItem("loginViaToken");
          window.location.href = redirectUrl;
        },
      });
    }
  }, []);

  if (isLoginViaToken && defaultYear?.acad_yr_id) return null;

  const onSelectAcdYr = () => {
    props.dispatch({
      type: "SWITCH_ACAD_YEAR_NEW",
      acadYearObj: selected,
      dashNavigate: () => (window.location.href = `${window.location.origin}/dashboard`),
    });
  };

  return (
    <div className="popup-login-div1">
      <div className="popup-login-div">
        <div className="popup-login">
          <div className="popup-heading">Select Academic Year</div>
          {props?.student_acad_year?.map((el, i) => (
            <label key={i} class="container-popupLogin">
              <div> Academic Year: {el?.acad_yr_name}</div>
              <input
                type="radio"
                name="radio"
                value={el?.acad_yr_id}
                checked={el?.acad_yr_id == selected}
                onChange={(e) => {
                  setSelected(Number(e.target.value));
                }}
              />
              <span class="checkmark"></span>
            </label>
          ))}
        </div>
        <div className="popuplogin-buttons">
          <button className="pop-button" onClick={onSelectAcdYr}>
            Ok
          </button>
          <button className="pop-button" onClick={props?.closeAcdYrPop}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({ ...state.auth });
export default connect(mapStateToProps)(AcadmicYear);
